import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect() {
    const memberTypeSelect = this.element.querySelector('select[name*="[member_type]"]')
    if (memberTypeSelect) {
      this.toggleFields({ target: memberTypeSelect })
    }
    
    const refereeRadios = this.element.querySelectorAll('input[name*="[is_referee]"]')
    if (refereeRadios.length > 0) {
      const checkedReferee = this.element.querySelector('input[name*="[is_referee]"]:checked')
      if (checkedReferee) {
        this.toggleRefereeFields({ target: checkedReferee })
      }
    }
  }

  toggleFields(event) {
    const selectedType = event.target.value
    
    const correctorFields = this.element.querySelectorAll('.jury-member-corrector-field')
    const supervisorFields = this.element.querySelectorAll('.jury-member-supervisor-field')
    const refereeFields = this.element.querySelectorAll('.jury-member-referee-field')
    
    correctorFields.forEach(field => field.classList.add('is-hidden'))
    supervisorFields.forEach(field => field.classList.add('is-hidden'))
    refereeFields.forEach(field => field.classList.add('is-hidden'))
    
    if (selectedType === 'corrector') {
      correctorFields.forEach(field => field.classList.remove('is-hidden'))
      // Re-check referee status when corrector is selected
      const checkedReferee = this.element.querySelector('input[name*="[is_referee]"]:checked')
      if (checkedReferee && checkedReferee.value === 'true') {
        this.toggleRefereeFields({ target: checkedReferee })
      }
    } else if (selectedType === 'supervisor' || selectedType === 'secretary' || selectedType === 'president' || selectedType === 'assistant') {
      supervisorFields.forEach(field => field.classList.remove('is-hidden'))
    }
    
    // Hide mission order field for secretary and supervisor
    const missionOrderFields = this.element.querySelectorAll('.jury-member-mission-order-field')
    if (selectedType === 'secretary' || selectedType === 'supervisor') {
      missionOrderFields.forEach(field => field.classList.add('is-hidden'))
    } else {
      missionOrderFields.forEach(field => field.classList.remove('is-hidden'))
    }
  }

  toggleRefereeFields(event) {
    const isReferee = event.target.value === 'true'
    const refereeFields = this.element.querySelectorAll('.jury-member-referee-field')
    
    if (isReferee) {
      refereeFields.forEach(field => field.classList.remove('is-hidden'))
    } else {
      refereeFields.forEach(field => field.classList.add('is-hidden'))
      // Clear referee_group and refers_to_jury_id when referee is set to false
      const refereeGroupSelect = this.element.querySelector('select[name*="[referee_group]"]')
      const refersToJurySelect = this.element.querySelector('select[name*="[refers_to_jury_id]"]')
      if (refereeGroupSelect) refereeGroupSelect.value = ''
      if (refersToJurySelect) refersToJurySelect.value = ''
    }
  }
}

